TrelloModel = require 'models/internal/trello-model'

module.exports = class Membership extends TrelloModel



// WEBPACK FOOTER //
// ./app/scripts/models/membership.coffee